
/* eslint-disable */



let PUSH_NOTIFICATION_ENABLE = configVars.PUSH_NOTIFICATION_ENABLE;


function generateSortFn(prop, reverse) {
  return function (a, b) {
    if (a[prop] < b[prop]) return reverse ? 1 : -1;
    if (a[prop] > b[prop]) return reverse ? -1 : 1;
    return 0;
  };
}
import { mapMutations, mapGetters } from "vuex";
import configVars from "@/config/config_vars";
let appFrontUrl = configVars.appFrontUrl;
let appBaseUrl = configVars.appBaseUrl;
let enableInvitation = configVars.enableInvitation;
import api from "@/api/api";
import util from "@/util/funtions_view";
import invitationsApi from "@/api/invitations";
import performersApi from "@/api/performers";
import book from "@/api/book/index";
import searches from "@/api/searches";
import eventsApi from "@/api/events";
import moment from "moment";
import microformatos from "@/api/microformatos";
import categoriesApi from "@/api/categories";


import fees from "@/api/fees";
import socket from '@/plugins/socket.io.js'
import { v4 as uuidv4 } from 'uuid';
import spotify from '@/api/spotify'
import Cookie from "js-cookie";

import scroll from '@/util/scroll'


/*import facebook from '@/api/facebook' */

export default {
  async asyncData(context) {
    try {


      let ip = "";
      if (context.req) {
        ip = context.req.headers["x-forwarded-for"];
        if (ip) {
          var list = ip.split(",");
          ip = list[list.length - 1];
        } else {
          ip = context.req.connection.remoteAddress;
        }


        context.store.commit("storeIP", ip);
      } else if (process.browser) {

        ip = context.store.getters.IP;
        if (ip != "") {
          localStorage.setItem("ip", ip);
        }
        if (localStorage.getItem("ip") != "") {
          ip = localStorage.getItem("ip");
        }
      }
      let currentDate = moment();
      let occurs_at_gte = moment(currentDate, moment.ISO_8601).format();


      let slug = "";
      let hasPerformerImage = false;


      let search = context.params.search;


      let venue_date = context.params.venue_date;
      let structuredData = [];
      let performerQuery;
      let categoryPerformer;

      slug = search

      if (!search) {
        context.error({ statusCode: 404, message: 'Post not found' })
        return
      }
      if (search === "innerwave") {
        search = "inner-wave";
      }
      let categoria_padre = 54;
      let loadingClass = "loading_concert";
      if (search === "cafe-tacvba-7bc9efad-ac42-447e-ad22-ea63588316e2") {
        //parche por ticket evo
        search = "cafe-tacvba";
      }
      search = search.replace(/-9-/gi, " ");
      search = search.replace(/-7-/gi, " ");
      search = search.replace(/-5-/gi, " ");
      search = search.replace(/-3-/gi, " ");
      search = search.replace(/-s-/gi, " ");
      search = search.replace(/-/gi, " ");
      search = search.replace(/  /gi, " ");

      search = search.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });


      let performerDB = {};
      let performerTevo = {};
      let performerOK = false;
      let performerWithImage = false;

      let performerByNameDB = {
        data: {

        }
      }
      let performersLikeNameDB

      try {
        performerByNameDB = await performersApi.getPerformerByName(slug)
      } catch (error) {

      }


      if (performerByNameDB) {
        performerDB = performerByNameDB.data;
        if (performerDB.performer_id != undefined) {
          performerDB.id = performerDB.performer_id;
          if (performerDB.imageUrl != undefined) {
            performerOK = true;
            if (performerDB.imageUrl.length > 0) {
              performerWithImage = true;
            }
          }
        }
      }


      if (performerOK === false) {
        try {
          performerByNameDB = await performersApi.getPerformerByName(search)
        } catch (error) {

        }


      }


      if (performerByNameDB) {
        performerDB = performerByNameDB.data;
        if (performerDB.performer_id != undefined) {
          performerDB.id = performerDB.performer_id;
          if (performerDB.imageUrl != undefined) {
            performerOK = true;
            if (performerDB.imageUrl.length > 0) {
              performerWithImage = true;
            }
          }
        }
      }




      if (performerOK === false) {
        let performers = [];
        if (performersLikeNameDB != undefined) {

          performers = performersLikeNameDB;
          performerDB = performers[0];

          for (let i = 0; i < performers.length; i++) {
            let pasa = true;
            if (performers[i].name.length == search.length) {
              if (performers[i].name != search) {
                pasa = false;
              }
              if (pasa == true) {
                performerByNameDB = performers[i];
              }
            }
          }
          if (performerDB != undefined) {
            if (performerDB.performer_id != undefined) {
              performerDB.id = performerDB.performer_id;
              if (performerDB.imageUrl != undefined) {
                performerOK = true;
                if (performerDB.imageUrl.length > 0) {
                  performerWithImage = true;
                }
              }

            }
          }
        }
      }
      if (performerDB != undefined) {
        if (performerDB.name != undefined) {

        }
      }


      if (performerOK === false) {
        let performersTevoRes = {
          data: {
            performers: []
          }
        }
        try {
          performersTevoRes = await performersApi.getPerformersSearch({ q: search })

        } catch (error) {

        }

        //console.log(performersTevoRes.data)
        performerTevo = performersTevoRes.data.performers.length > 0 ? performersTevoRes.data.performers[0] : null;



        let performers = performersTevoRes.data.performers;

        for (let i = 0; i < performers.length; i++) {
          let pasa = true;
          if (performers[i].name.length == search.length) {
            if (performers[i].name != search) {
              pasa = false;
            }
            if (pasa == true) {
              performerTevo = performers[i];
            }
          }
        }

        if (performerTevo != undefined) {

          if (performerTevo.id != undefined) {


            if (
              performerTevo.category != undefined &&
              performerTevo.category != "null"
            ) {
              if (performerTevo.category.id) {


                if (performerTevo.category.parent) {
                  if (performerTevo.category.parent.parent) {
                    if (performerTevo.category.parent.parent.id) {
                      categoria_padre = performerTevo.category.parent.parent.id;
                    } else {
                      categoria_padre = performerTevo.category.parent.id;
                    }
                  } else {
                    categoria_padre = performerTevo.category.parent.id;
                  }
                } else {
                  categoria_padre = performerTevo.category.id;
                }
              }
            }

            switch (categoria_padre) {
              case 1:
                {
                  loadingClass = "loading_sport";
                  //performerTevo.imageUrl = "/img/no-image/no_image_sport.jpg";
                }
                break;
              case 54:
                {
                  loadingClass = "loading_concert";
                  //performerTevo.imageUrl = "/img/no-image/no_image_concert.jpg";
                }
                break;
              case 68:
                {
                  loadingClass = "loading_theatre";
                  //performerTevo.imageUrl = "/img/no-image/no_image_theater.jpg";
                }
                break;
              case 73:
                {
                  loadingClass = "loading_special";
                  //performerTevo.imageUrl ="/img/no-image/no_image_special_event.jpg";
                }
                break;
              default:
                {
                  loadingClass = "loading_concert";
                  //performerTevo.imageUrl = "/img/no-image/no_image_concert.jpg";
                }
                break;
            }

          }
        } else {
        }
      }



      let performer = {};
      let lookforImage = false
      if (performerDB && performerDB.performer_id) {
        performer = performerDB;
        performer.id = performer.performer_id
      } else if (performerTevo && performerTevo.id) {
        performer = performerTevo;
        performer.performer_id = performer.id
        lookforImage = true
      }



      //console.log(performer)

      let events = [];
      let factorFees = 0;
      let category_id = 0;

      if (!performer || !performer.id) {
        context.error({ statusCode: 404, message: 'Performer not found' })
        return

      }

      if (performer != undefined && performer.id) {
        performer.performer_id = performer.id;
        let currentDate = moment();
        let occurs_at_gte = moment(currentDate, moment.ISO_8601).format();

        performerQuery = {
          "occurs_at.gte": occurs_at_gte,
          only_with_tickets: 'all',
          order_by: "events.occurs_at ASC",
          page: 1,
          per_page: 5,
          performer_id: performer.performer_id,
          //min_and_max_price: true,
          //short_term_popularity_score: 10,
          //only_with_tickets: "all",
        };


        if (performer.category) {
          if (performer.category.id) {
            category_id = performer.category.id;
          }
        } else if (performer.category_id) {
          category_id = performer.category_id;
        }

        let performerBDRes = {
          data: {

          }
        }
        let categoriesRes = {
          data: []
        };
        let feesRes = {
          value: 0.21
        }


        try {
          [events, categoriesRes] = await Promise.all([
            eventsApi.actionGetEventTevoQuery2(performerQuery),
            categoriesApi.searchCategoriesById(category_id)
          ])


        } catch (error) {
          console.log('Error: ' + error)
        }


        if (feesRes.value != undefined && feesRes.value >= 0) {
          factorFees = feesRes.value;
        }


        if (categoriesRes.data[0] && categoriesRes.data.length > 0) {
          if (categoriesRes.data[0].id) {
            categoryPerformer = categoriesRes.data[0];
          }
        }

        if (lookforImage == true) {
          try {
            performerBDRes = await performersApi.getBDPerformerById(performer.performer_id)
          } catch (error) {
            console.log('Error: ' + error)
          }


          if (performerBDRes.data != undefined) {
            if (performerBDRes.data.performer_id != undefined) {
              if (performerBDRes.data.imageUrl != undefined) {
                performer.imageUrl = performerBDRes.data.imageUrl;
                hasPerformerImage = true;
              }
            }

            if (performerBDRes.data.meta != undefined) {
              if (performerBDRes.data.meta.description.length >= 10) {
                performer.meta = performerBDRes.data.meta;
              }
            }
          }
        }
        if (context.params.venue_date != undefined) {
          var replace = context.params.venue_date;
          replace = replace.replace(/-/gi, ", ");
          var re = new RegExp(replace, "ig");

          events = events.filter(evento => {
            return (
              evento.venue.location.match(new RegExp(re)) ||
              evento.venue.name.match(new RegExp(re))
            );
          });
        }
        structuredData = microformatos.getEventsStructuredData(events);

        if (events.length > 0 && events[0] != undefined) {
          if (events[0].category) {
            if (events[0].category.id) {


              if (events[0].category.parent) {

                if (events[0].category.parent.parent) {

                  if (events[0].category.parent.parent.id) {

                    categoria_padre = events[0].category.parent.parent.id;
                  } else {

                    categoria_padre = events[0].category.parent.id;
                  }
                } else {

                  categoria_padre = events[0].category.parent.id;
                }
              } else {

                categoria_padre = events[0].category.id;
              }
            }
          }

          switch (categoria_padre) {
            case "1":
              {
                loadingClass = "loading_sport";
              }
              break;
            case "54":
              {
                loadingClass = "loading_concert";
              }
              break;
            case "68":
              {
                loadingClass = "loading_theatre";
              }
              break;
            case "73":
              {
                loadingClass = "loading_special";
              }
              break;
            default:
              {
                loadingClass = "loading_sport";
              }
              break;
          }
        }
      }
      let notFoundEvents = false;
      if (events.length <= 0) {
        notFoundEvents = true;
      }
      let showFollowOnSpotify = false
      //55, 56, 63
      let musicCategories = [60, 61, 62, 64, 65, 67, 54, 58, 82, 83, 84, 85, 86, 59, 57]
      for (const categoryId of musicCategories) {
        if (category_id == categoryId) {
          showFollowOnSpotify = true
        }

      }

      if (performer.id && !performer.performer_id) {
        performer.performer_id = performer.id
      }
      if (!performer.id && performer.performer_id) {
        performer.id = performer.performer_id
      }





      return {
        showFollowOnSpotify,
        performerQuery,
        categoryPerformer,
        slug: slug,
        performer,
        events,
        categoria_padre,
        loadingClass,
        notFoundEvents,
        structuredData,
        hasPerformerImage,
        ip,
        venue_date,
        factorFees,
        factorFeesIncreased: 100 / (100 - factorFees * 100),
      };
    } catch (error) {
      console.error('Error in book asyncData:', error);
      return context.error({ statusCode: 500, message: 'Internal Server Error' });
    }

  },
  async fetch({ store, params }) { },
  head() {
    if (this.performer.name) {
      let year = new Date().getFullYear();
      let keywords = "";
      let keyname = this.performer.name.toLowerCase();
      keywords = `${keyname} tickets`;
      let description = `Tickets for ${this.performer.name} events`;
      let title = `Tickets for ${this.performer.name}  | Pepper Tix`;

      if (this.categoryPerformer) {
        if (this.categoryPerformer.meta) {
          if (this.categoryPerformer.meta.performers) {
            if (this.categoryPerformer.meta.performers.description) {
              description = this.categoryPerformer.meta.performers.description;

              description = description.replace(
                /{{category.name}}/gi,
                this.categoryPerformer.name
              );

              description = description.replace(
                /{{performer.name}}/gi,
                this.performer.name
              );

              let locality = "";
              if (this.venue_date != undefined) {
                if (this.events != undefined) {
                  if (this.events[0] != undefined) {
                    if (this.events[0].venue != undefined) {
                      locality = ` at ${this.events[0].venue.location}`;
                    }
                  }
                }
              }
              description = description.replace(/{{locality}}/gi, locality);
            }
          }
        }
      }

      if (this.performer.meta) {
        if (this.performer.meta.description) {
          description = this.performer.meta.description;
        }
      }

      return {
        title: title,



        meta: [
          {
            hid: "description",
            name: "description",
            content: description
          },
          {
            hid: "keywords",
            name: "keywords",
            content: keywords
          },
          {
            hid: "og:description",
            name: "og:description",
            content: description
          },
          {
            property: "og:site_name",
            content: `Pepper Tix`
          },
          {
            property: "og:url",
            content: `${appFrontUrl}book/${this.performer.slug}`
          },
          {
            property: "og:type",
            content: "peppertix:performer"
          },
          {
            property: "og:title",
            content: description
          },
          {
            property: "og:image",
            content: this.performer.imageUrl
          }
        ],

        __dangerouslyDisableSanitizers: ["script"],
        script: [
          {
            innerHTML: JSON.stringify(this.structuredData),
            type: "application/ld+json"
          },
          //{ src: 'https://sdk.scdn.co/spotify-player.js' }
          //{ src: 'https://sdk.scdn.co/spotify-player.js', body: true }//https://developer.spotify.com/documentation/web-playback-sdk/quick-start/
        ],




      };
    }
  },

  computed: {
    ...mapGetters({
      user: "user/user",
      isAutenticated: "user/isAutenticated",
      prospect: "user/prospect",
      media_match: "media_match",
      isCreatedNewInvitation: "isCreatedNewInvitation",
      isFavorite: "user/isFavorite",
      spotifyToken: "user/spotifyToken",
      tooglePromoRegister: "tooglePromoRegister",
      activePromoCode: "checkout/activePromoCode",

      promoCodeFromUrl: "checkout/promoCodeFromUrl",
      promoCodeForApply: "user/promoCodeForApply",
      showPromoToast: "showPromoToast",
      isActivePromoBeenSetUp: "checkout/isActivePromoBeenSetUp",
    }),
    containerBookUp: function () {
      if (this.on_scroll_transition == true) {
        if (this.isActivePromoBeenSetUp == true && this.activePromoCode) {
          return "container_book_up on_scroll bajar_por_promo";
        } else {
          return "container_book_up on_scroll";
        }
      } else {
        if (
          this.isActivePromoBeenSetUp == true && this.activePromoCode
        ) {
          return "container_book_up bajar_por_promo";
        } else {
          return "container_book_up";
        }
      }
    },
    containerContentBody: function () {
      if (this.on_scroll_transition == true) {
        if (this.isActivePromoBeenSetUp == true && this.activePromoCode) {

          return "container_content_body on_scroll bajar_por_promo_2";
        } else {
          return "container_content_body on_scroll";
        }
      } else {
        if (
          this.isActivePromoBeenSetUp == true && this.activePromoCode
        ) {

          return "container_content_body bajar_por_promo_2";
        } else {
          return "container_content_body";
        }
      }
    },

  },
  data() {
    return {

      toogleEnjoyVIPPriceModal: false,
      userIsVIPMember: false,
      player: null,

      one_signal_id: "",
      toogleNotification: false,
      toogleFollowOnSpotifyModal: false,
      PUSH_NOTIFICATION_ENABLE: PUSH_NOTIFICATION_ENABLE,
      resta: 0,
      promoToastMessage: "Hey!!! Get a {{promo.name}} discount", //TODO: "Hey!!! Get a 10% promo code",
      promoName: "",
      promoToastButtonText: "GET CODE",
      originalPerformerMatch: false,


      isUserVerified: false,

      structuredData: {},
      showProgress: true,
      snackbar: false,
      promoSnackbar: true,
      mode: "vertical",
      timeout: 2000,
      text: "Questions? Chat with us!",
      notFoundEvents: null,
      showCrispChat: false,
      loadingClass: "",

      enableInvitation: enableInvitation,
      hasActivatedInvitation: false,
      invitation: {},
      senderId: this.$route.query.senderId,
      invitation_code: this.$route.query.invitation_code,
      appFrontUrl: appFrontUrl,
      title: this.$route.params.search,
      description: `Your Home For ${this.$route.params.search} tickets`,
      performer: {},

      toogleSignIn: false,
      tooglePromoSignIn: false,

      toogleInviteFriends: false,
      event_name: this.$route.params.search,
      on_scroll_transition: false,
      imgObj: {
        error: "/img/event.jpg"
      },
      img: {},
      imgError: "/img/event.jpg",
      imgLoading: "/img/loader.gif",
      events: [],
      imageUrl: "/img/event.jpg",
      isLoading: true,
      //isFavorite: false,
      myArtists: "",
      sortByDateProp: true,
      sortByPriceProp: true,
      sortByVenueNameProp: true,
      lat: 0,
      lon: 0
    };
  },
  watch: {
    paddingBottomComputed: function (val) {

    },
    showPromoToast: function (val) {
      if (val === false) {
        if (this.tooglePromoRegister === false) {
          this.$chat.showChat();
        }
      } else {
        this.$chat.hideChat();
      }
    },

    snackbar: function (val) {
      if (val == false) {
        this.$chat.showChat();
      }
    },
    isAutenticated: function (val) {

      /*for (let j = 0; j < this.myArtists.length; j++) {
        if (this.performer.id == this.myArtists[j].performer_id) {

          //this.isFavorite = true;
          this.$store.dispatch("user/setIsFavorite", true);


        }
      }*/
      if (val == true) {
        //this.verifyHasPromoCode();
        this.init()
      } else {
        this.$store.dispatch("user/setIsFavorite", false);
        this.$store.commit("user/spotifyToken", null);
        this.$store.commit("storeFollow", false);
        this.userIsVIPMember = false;
        this.isUserVerified = false

      }
    },

    isCreatedNewInvitation: function (val, oldVal) {
      if (val == true) {


        if (this.user && this.performer) {
          let invitacionQuery = {
            inviterId: this.user._id,
            performerId: this.performer.performer_id,
            resumen: true
          };


          invitationsApi.getInvitation(invitacionQuery).then(invitations => {
            if (invitations._id) {
              if (true) {
                this.hasActivatedInvitation = true;
                this.invitation = invitations;
              }
            }
          });
        } else {

        }
      } else {
      }
    },
    tooglePromoSignIn: function (newVal) {
      let className = "modal-open";

      if (newVal) {

      } else {

      }
    },
    toogleSignIn: function (newVal) {


      if (newVal) {

      } else {

      }
    },//toogleNotification
    toogleNotification: function (newVal) {
      let className = "modal-open";

      if (newVal) {

      } else {

      }
    },

    toogleFollowOnSpotifyModal: function (newVal) {
      let className = "modal-open";

      if (newVal) {

      } else {

      }
    },



    tooglePromoRegister: function (newVal) {
      let className = "modal-open";

      if (newVal) {

      } else {

      }
    }
  },
  async created() {




  },
  mounted() {

    //this.$store.commit("ClickBody", false);
    this.$nextTick(async () => {
      this.$store.commit("checkout/selectedTicketGroup", null)
      /*setTimeout(()=>{
        FB.XFBML.parse();
        FB?.CustomerChat?.show(false);
      }, 500)*/

      /*if(!window.fbAsyncInit)
      facebook.facebook(true, ()=> {
        setTimeout(()=>{
          //FB?.XFBML.parse();
          FB?.CustomerChat?.show(false);


        }, 1000)
      })*/

      document.addEventListener('mousemove', this.initLoadEvents);
      document.addEventListener('touchstart', this.initLoadEvents);


      this.$store.commit("storeFollow", false);
      /*window.onSpotifyWebPlaybackSDKReady = () => {
        this.spotifyToken = '';
        this.player = new Spotify.Player({
          name: 'Web Playback SDK Quick Start Player',
          getOAuthToken: cb => { cb(this.spotifyToken); }
        });

        // Error handling
        this.player.addListener('initialization_error', ({ message }) => { console.error(message); });
        this.player.addListener('authentication_error', this.spotifyAuthError);
        this.player.addListener('account_error', ({ message }) => { console.error(message); });
        this.player.addListener('playback_error', ({ message }) => { console.error(message); });

        // Playback status updates
        this.player.addListener('player_state_changed', state => { });

        // Ready
        this.player.addListener('ready', this.spotifyPlayerReady);

        // Not Ready
        this.player.addListener('not_ready', ({ device_id }) => {

        });

        // Connect to the player!
        this.player.connect();
      };*/


      let maxHeight = Math.max(
        window.innerHeight || 0,
        window.outerHeight || 0
      );
      let minHeight = Math.min(
        window.innerHeight || 0,
        window.outerHeight || 0
      );





      if (this.media_match === 0) {
        //primera screen and (max-width: 600px)

        //brice aki
        document.getElementById(
          "contenedor_principal"
        ).style.minHeight = `${minHeight - 154}px`;
      } else if (this.media_match === 1) {
        //segunda screen and (min-width: 601px) and (max-width: 767px)
      } else if (this.media_match === 2) {
        //tercera screen and (min-width: 768px) and (max-width: 991px)
      } else if (this.media_match === 3) {
        //cuarta screen and (min-width: 992px) and (max-width: 1199px)





      } else if (this.media_match === 4) {
        //quinta screen and (min-width: 1200px)
      }


      window.addEventListener('chatwoot:ready', function () {
        window.$chatwoot.toggleBubbleVisibility("hide");
      });

      if (window.$chatwoot) {
        window.$chatwoot.toggleBubbleVisibility("hide");
      }


      this.$store.commit("changeCreateNewInvitation", false);

      document.addEventListener("scroll", this.handleScroll);

      document.addEventListener("resize", this.windowResize);


      document.addEventListener("touchmove", this.windowResize, false);

      document.addEventListener("fullscreenChange", function () {

        console.info("Went full screen");

      });



      document.addEventListener("touchleave", this.windowResize, false);
      document.addEventListener("touchend", this.windowResize, false);

      if (window.fbq)
        window.fbq("track", "ViewContent");



      if (this.senderId != undefined) {
        let parametros = {
          senderId: this.senderId
        };
        api.searchMessengerUser(parametros).then(response => {
          util.removeParam("senderId");

          if (response.data) {
            let email = response.data.email;
            let password = response.data.password;
            let tipo = response.data.tipo;
            let messengerUser = {
              email,
              password,
              tipo,
              senderId: this.senderId
            };

            if (messengerUser != null) {

              if (messengerUser.email && messengerUser.password) {
                let newMessengerUser = {
                  email: messengerUser.email,
                  password: messengerUser.password,
                  senderId: messengerUser.senderId
                };

                this.$store
                  .dispatch("user/signin", newMessengerUser)
                  .then(response => { });
              } else {
              }
            } else {

            }
          }
        });
      }




      let total_entries = 100
      if (this.events.length > 0) {
        if (this.events[0].total_entries) {
          total_entries = this.events[0].total_entries
        }
      }

      let eventsPromises = []
      let fin = Math.floor(total_entries / this.performerQuery.per_page) - 1
      if (fin <= 0) {
        fin = 0
      }
      let page = this.performerQuery.page
      if (this.events.length == 0) {
        page = 0
        fin++
      }

      for (let i = 1; i <= fin; i++) {
        page = page + 1
        let query = { ...this.performerQuery, page: page }

        eventsPromises.push(eventsApi.actionGetEventTevoQuery2(query))
      }

      this.isLoading = true
      const promisesRes = await Promise.all(eventsPromises)

      this.isLoading = false
      promisesRes.forEach((moreEvents) => {

        this.events = this.events.concat(moreEvents);
      })
      setTimeout(() => {
        this.scrollToElement(`hash${this.$route.query.event}`)
      }, 100)



      if (this.hasPerformerImage == false) {

        this.errorPerformerImage();
      } else if (this.hasPerformerImage == true) {
      }


      api.getLocationInfo(this.ip).then((info) => {
        this.lat = info.data.latitude;
        this.lon = info.data.longitude;
        this.$store.commit("storeCoordinates", { lat: this.lat, lon: this.lon });
      }).catch((error) => {
        console.log(error)
      })








      this.init();


      try {
        this.$OneSignal?.push(() => {
          return Promise.all([
            this.$OneSignal?.isPushNotificationsEnabled(),
            this.$OneSignal?.isOptedOut(),
            this.$OneSignal?.getUserId()
          ]).then(result => {
            let isEnabled = result[0];
            let isOptedOut = result[1];
            let oneSignalID = result[2];


            this.$OneSignal?.setSubscription(true);
            if (isEnabled) {


            } else {
              this.toogleNotification = true;
              this.$OneSignal?.setSubscription(true);

              if (isOptedOut) {
                //this.$OneSignal?.setSubscription(true);

              } else {
                if (Notification.permission !== "granted") {
                  Notification.requestPermission();

                  if (Notification.permission === "denied") {

                    //this.$OneSignal?.showNativePrompt();
                    /*this.$OneSignal?.push(() => {
                        this.$OneSignal?.showSlidedownPrompt();
                      });*/
                  }
                }
                this.$OneSignal?.showNativePrompt();

                this.$OneSignal?.registerForPushNotifications();
              }
            }
          }).catch(error => {

          })
        });
      } catch (error) {

      }

    });
  },
  methods: {
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      console.log(element)
      if (!element) return
      window.scrollTo({
        top: element.offsetTop - 450,
        behavior: 'smooth'
      });
    },
    initLoadEvents(event) {
      //this.$gtm.init('GTM-P63HHPN')
      /*facebook.facebook(true, ()=> {
        //FB.XFBML.parse();
        FB?.CustomerChat?.show(false);

      }) */

      event.currentTarget.removeEventListener(event.type, this.initLoadEvents);

    },

    closeSignIn() {
      this.$store.commit("toogleSignIn", false)
      this.$store.commit("showPromoToast", true)
      this.$store.commit("ClickBody", true)
    },
    openSignIn() {

      this.$store.commit("signinform/signUpModePromo", false)
      this.$store.commit("signinform/toogleSignUp", false)
      this.$store.commit("userPromoAdded", false);
      this.$store.commit("showPromoToast", false)
      this.$store.commit("toogleSignIn", true)
      this.$store.commit("ClickBody", false)
      scroll.blockScroll(true)

    },

    openEnjoyVIPPriceModal() {
      this.toogleEnjoyVIPPriceModal = true;
    },
    closEnjoyVIPPriceModal() {
      this.toogleEnjoyVIPPriceModal = false;
    },
    spotifyGetOAuthToken(cb) {

      cb(this.spotifyToken)
    },
    spotifyAuthError({ message }) {
      console.error(message + 'Wi no sirve pero....')

    },
    spotifyPlayerReady({ device_id }) {

    },
    spotifyAuth(spotifyAuth) {

      let spotifySessionId = uuidv4()

      var width = 450,
        height = 730,
        left = screen.width / 2 - width / 2,
        top = screen.height / 2 - height / 2;


      var w = window.open(
        `http://localhost:3069/sp/spotify_authorization?spotifySessionId=${spotifySessionId}`,
        `Spotify`,
        `menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height= ${height}, top=${top}, left=${left}`
      );


      socket.emit('spotifyToken', {}, (message) => {

      })


      socket.on('spotifyToken', (message) => {

        if (message.spotifySessionId === spotifySessionId) {
          spotifyAuth(message)
        }

        w.close()
      })




    },

    spotifyLogin() {
      this.spotifyAuth(async message => {

        this.spotifyToken = message.access_token
        this.player.getOAuthToken = cb => { cb(this.spotifyToken); }

        /*this.player = new Spotify.Player({
          name: 'Web Playback SDK Quick Start Player',
          getOAuthToken: cb => { cb(this.spotifyToken); }
        });*/


        /*let userData = null
        try{

          userData = await spotify.getMe(message.access_token)
        }catch(error){

        }
        if(userData){

        }*/


















      })
    },


    closeNotification() {
      this.toogleNotification = false;
    },

    closeFollowOnSpotifyModal() {
      this.toogleFollowOnSpotifyModal = false;
    },

    openFollowOnSpotifyModal() {
      this.toogleFollowOnSpotifyModal = true;
      if (this.spotifyToken)
        this.favoriteClick(true)
    },




    clickGetCode() {
      if (!this.user) {
        this.tooglePromoSignIn = true;
      } else {
        this.$router.push(`/get_promo/${this.performer.name}`);
      }
    },
    clickGetCodePromoRegister() {
      this.$store.commit("signinform/signUpModePromo", false)
      this.$store.commit("signinform/toogleSignUp", true)
      this.$store.commit("toogleSignIn", true)
      this.$store.commit("showPromoToast", false)

    },


    /*clickGetCodePromoRegister(){
      this.$store.commit("signinform/signUpModePromo", false )
      this.$store.commit("signinform/toogleSignUp", true )
      this.$store.commit("toogleSignIn", true )
      this.$store.commit("showPromoToast", false )
    },*/

    clickSkip() {

    },
    clickShowCrispChat() {
      this.showCrispChat = !this.showCrispChat;
      this.snackbar = false;

      if (this.showCrispChat === true) {
        this.$chat.showChat();
      } else {
        this.$chat.hideChat();
      }
    },
    goBack() {
      if (window.history.length <= 2) {
        this.$router.push(`/`);
      } else {
        window.history.back();
      }

    },
    ClickBody() {
      this.$store.commit("ClickBody", true);

    },

    async init() {

      this.$store.dispatch("user/setIsFavorite", false);
      if (this.performer == undefined || this.performer == null) {
        return
      }
      let data = await this.$store.dispatch("user/updateUser")
      this.isUserVerified = true;

      if (!this.user) {
        return
      }
      let artists = this.user.music;
      this.myArtists = artists;

      let sports = [];
      let theatre = [];
      let special_events = [];

      if (this.user.sports.length > 0) {
        sports = this.user.sports;
        this.myArtists = this.myArtists.concat(sports);
      }
      if (this.user.theatre.length > 0) {
        theatre = this.user.theatre;
        this.myArtists = this.myArtists.concat(theatre);
      }
      if (this.user.special_events.length > 0) {
        special_events = this.user.special_events;
        this.myArtists = this.myArtists.concat(special_events);
      }


      for (let j = 0; j < this.myArtists.length; j++) {
        if (this.performer.id == this.myArtists[j].performer_id) {
          this.$store.dispatch("user/setIsFavorite", true);
        }
      }
    },

    clickInviteFriends() {
      this.toogleInviteFriends = true;

    },
    facebookShareLink(performer) {
      if (performer != undefined) {
        let name = performer.name;
        let share = `${appFrontUrl}/book/${name}`;
        return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          share
        )}&amp;src=sdkpreparse`;
      }
    },
    adjust_content: function () {
      var tabla_data = this.$refs["content_book_list_body"].clientHeight;
    },
    windowResize: function (event) {

      //event.preventDefault();
      let maxHeight = Math.max(
        window.innerHeight || 0,
        window.outerHeight || 0
      );
      let minHeight = Math.min(
        window.innerHeight || 0,
        window.outerHeight || 0
      );


      if (this.media_match === 0) {
        //primera screen and (max-width: 600px)
        //brice aki
        if (document.getElementById("contenedor_principal"))
          document.getElementById(
            "contenedor_principal"
          ).style.minHeight = `${minHeight - 154}px`;

      }

    },

    handleScroll: function (event) {
      let currentScrollPosition = window.pageYOffset; //document.documentElement.scrollTop;
      currentScrollPosition =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;

      if (currentScrollPosition > 0) {
        this.on_scroll_transition = true;

      } else {
        this.on_scroll_transition = false;
      }


    },

    getRoute(event) {
      let performerName = this.performer.name;

      performerName = performerName.replace(/ /gi, "-");
      performerName = performerName.replace(/,/gi, "-");
      performerName = performerName.replace(/--/gi, "-");
      performerName = performerName.toLowerCase();

      let venueLocation = event.venue.location;
      venueLocation = venueLocation.replace(/ /gi, "-");
      venueLocation = venueLocation.replace(/,/gi, "-");
      venueLocation = venueLocation.replace(/--/gi, "-");
      venueLocation = venueLocation.toLowerCase();

      let venueName = event.venue.name;
      venueName = venueName.replace(/ /gi, "-");
      venueName = venueName.replace(/,/gi, "-");
      venueName = venueName.replace(/--/gi, "-");
      venueName = venueName.toLowerCase();

      let hour = event.hour;
      hour = hour.replace(/ /gi, "-");
      hour = hour.replace(/:/gi, "-");
      let eventFecha = `${event.year}-${event.month2}-${event.day2}-${hour}`;

      let ruta = `/book/${performerName}/${venueLocation}-${venueName}-${eventFecha}/${event.id}`;

      return ruta;
    },

    getPriceIncreased(event) {

      let min_price_s = ``;
      if (event.min_price) {
        let min_price_f = parseFloat(event.min_price / (1 + this.factorFees)).toFixed(0);
        min_price_f = parseFloat(this.factorFeesIncreased * min_price_f).toFixed(0);
        min_price_s = `$${min_price_f}`;
        return min_price_s;
      } else {
        if (this.media_match == 0) {
          min_price_s = `Find`;
        } else {
          min_price_s = `Find Tickets`;
        }

        return min_price_s;
      }


    },


    getPrice(event) {
      let min_price_s = ``;

      if (event.min_price) {
        let min_price_f = parseFloat(event.min_price / (1 + this.factorFees)).toFixed(0);
        min_price_s = `$ ${min_price_f}`;
        return min_price_s;
      } else {
        if (this.media_match == 0) {
          min_price_s = `Find`;
        } else {
          min_price_s = `Find Tickets`;
        }

        return min_price_s;
      }
    },
    sortByDate() {
      this.sortByDateProp = !this.sortByDateProp;
      this.events.sort(generateSortFn("occurs_at", this.sortByDateProp));
    },
    sortByVenueName() {
      this.sortByVenueNameProp = !this.sortByVenueNameProp;
      this.events.sort(
        generateSortFn("venue_location", this.sortByVenueNameProp)
      );
    },
    sortByPrice() {
      this.sortByPriceProp = !this.sortByPriceProp;
      this.events.sort(generateSortFn("min_price", this.sortByPriceProp));
    },

    closeSignIn() {
      this.toogleSignIn = false;
    },
    closePromoSignIn() {
      this.tooglePromoSignIn = false;
    },

    closePromoRegister() {
      this.$store.commit("tooglePromoRegister", false)
      this.$store.commit("showPromoToast", true);
    },

    closeInviteFriends() {
      this.toogleInviteFriends = false;
    },

    async favoriteClick(followOn = false) {
      let performerForSave = {
        performer_id: this.performer.id,
        name: this.performer.name,
        images: [],
        popularity_score: this.performer.popularity_score,
        category_id: this.performer.category_id, // this.performer.category.id,
        category_name: this.performer.category_name, //this.performer.category.name,
        activado: true
      };
      let datos = {
        performers: [performerForSave],
        category_id: this.categoria_padre
      };

      if (this.isAutenticated == false) {
        if (followOn == false)
          this.toogleSignIn = true;
        this.openSignIn()
        this.$store.dispatch("user/setPerformersToSave", datos);
      } else {
      }

      //this.isFavorite = !this.isFavorite;


      if (this.isAutenticated == true && this.prospect) {
        this.openSignIn()
        return
      }


      if (this.isAutenticated == true) {


        let newFavoriteState = !this.$store.getters["user/isFavorite"]


        this.$store.dispatch("user/setIsFavorite", newFavoriteState);

        if (followOn == true) {
          this.$store.dispatch("user/setIsFavorite", true);


          try {
            let response = await spotify.meFollowing(this.performer.name, this.spotifyToken)

          } catch (error) {
          }

        }


        if (this.isFavorite == true) {

          this.$store
            .dispatch("user/setUserPerformers", datos)
            .then(response => {

              this.$store.dispatch("user/myArtists").then(artists => {
                this.myArtists = artists;
              });
            })
            .catch(error => {

            });
        } else {
          let borrar = [];

          borrar.push(performerForSave);
          this.$store
            .dispatch("user/deleteUserSeleccionados", borrar)
            .then(response => {
              this.$store.dispatch("user/myArtists").then(artists => {
                this.$store.dispatch("user/updateUser");
              });
            })
            .catch(error => {

            });


        }
      } else {


      }
    },
    handler(component) {

    },

    updateEventPrice(event) {
      let params = {
        event_id: event.id,
        page: 1,
        per_page: 5
      };
      this.$store
        .dispatch("events/searchTicketGroup", params)
        .then(ticketGroups => {
          if (ticketGroups.data.ticket_groups[0]) {

            event.from = `From $ ${parseFloat(
              ticketGroups.data.ticket_groups[0].retail_price
            ).toFixed(0)}`;
          }
        });
    },

    errorEventImage() {
      this.imageUrl = "/img/event.jpg";
    },
    async errorPerformerImage() {

      if (!this.performer) {
        return
      }






      /*performersApi.updatePerformerById(this.performer.id, true).then(res => {
        let resPerformer = res.data;
        if (resPerformer.imageUrl) {
          this.performer.imageUrl = resPerformer.imageUrl;
        }
      }).catch((error)=>{})*/


    }
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.windowResize);
    document.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("resize", this.windowResize);

    window.onscroll = null
    document.onscroll = null
    window.onresize = null
    document.onresize = null


    document.removeEventListener("touchmove", this.windowResize);

    document.removeEventListener("fullscreenChange", this.windowResize);
  }
};
